(function($) {
	"use strict";
	
	function init() {
		$('.dashboard-notification__seen-btn').on('click', onSeenClick);
	}

	function onSeenClick({ currentTarget }) {
		let { id } = currentTarget.dataset;
		let elt = $(currentTarget);
		let row = elt.closest('.table__tr');

		$.ajax({
			url: '/action/manageGenData',
			type: 'POST',
			data: {
				id: id,
				ajax: true,
				field4: 'true',
			}
		});

		row.removeClass('inactive');
		row.find('.bullet').remove();
	}
	
	$(init);
	
})(jQuery);